import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { debounceTime } from 'rxjs/operators';
import { StepThreeSliderComponent } from './step-three-slider/step-three-slider.component';
import { ThreeDService } from 'src/app/services/three-d.service';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss'],
})
export class StepThreeComponent implements OnInit {
  length: number;
  width: number;
  height: number;

  @ViewChild('lengthSlider', { static: true }) lengthSlider: StepThreeSliderComponent;
  @ViewChild('widthSlider', { static: true }) widthSlider: StepThreeSliderComponent;
  @ViewChild('heightSlider', { static: true }) heightSlider: StepThreeSliderComponent;

  constructor(
    private configurationService: ConfigurationService,
    private threeDService: ThreeDService
  ) {}

  ngOnInit() {
    this.threeDService.setZoom(5);
    this.threeDService.resetDefaultCamera(true);
    this.configurationService.furthestStepVisited = 3;

    this.length = this.configurationService.length;
    this.width = this.configurationService.width;
    this.height = this.configurationService.height;

    this.lengthSlider.valueChange.pipe(debounceTime(500)).subscribe(length => this.updateLength(length));
    this.widthSlider.valueChange.pipe(debounceTime(500)).subscribe(width => this.updateWidth(width));

    this.heightSlider.valueChange.pipe(debounceTime(500)).subscribe(height => this.updateHeight(height));
  }

  updateLength(length: number) {
    this.configurationService.length = length;
  }
  updateWidth(width: number) {
    this.configurationService.width = width;
  }
  updateHeight(height: number) {
    this.configurationService.height = height;
  }

  get maxWidth(): number {
    if (this.configurationService.length > 3900) {
      return 3900;
    }
    return 12000;
  }

  get maxLength(): number {
    if (this.configurationService.width > 3900) {
      return 3900;
    }
    return 12000;
  }
}
